module.exports = __webpack_public_path__ + "static/fonts/NotoSans-Light.d04dd87.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/myprotein-test/assets/fonts/NotoSans-Light.woff
// module id = s1+S
// module chunks = 0